import { useState, useEffect, useContext } from "react"
import { UserContext } from "../context/userContext"

import api from "../api/axiosInstance"

export default function useGetFormDef(args) {
  const userCtx = useContext(UserContext)

  const { formId, endpoint } = args
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [data, setData] = useState(null)

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await api.post(`/${endpoint}`, {
          formId,
          user_role: userCtx.user_role,
        })
        const parsedData = JSON.parse(res.data.data)
        setData(parsedData)
        setLoading(false)
      } catch (err) {
        setError(err)
        setLoading(false)
      }
    }
    fetch()
  }, [])

  return [error, loading, data]
}
